import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import {ConditionalSection, QuoteFormConditionalSection} from 'Quoting/components/shared/QuoteFormConditionalSection';
import {Map as ImmutableMap} from 'immutable';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {FormRowGrid, GridRowProps} from '../../../../shared/GridRow';
import {QuoteFormElement} from '../../../../shared/QuoteFormElement';
import {FormWrapper} from '../../../../shared/QuoteFormWrapper';
import {getParentSchedulePath} from '../Common/PropertyPaths';

export const CriticalIllnessSeparationPeriod = () => {
  const {getQuoteFieldValue, updateQuoteFieldValue} = useQuoteField();
  const {selectedPlan} = useSelector((state: ReducerState) => state.quoteForm);
  const parentPath = getParentSchedulePath(selectedPlan?.planIndex);
  const separationPeriodCdPath = `${parentPath}.separationPeriodDetails.separationPeriodCd`;

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'critical-illness-separation-period-row-1'},
      items: [
        {
          key: 'benefitSchedule.separationPeriodDetails.separationPeriodCd',
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              searchKey={'CISeparationPeriodBenefit.separationPeriodCd'}
              label="Separation Period"
              value={getQuoteFieldValue(separationPeriodCdPath)}
              id={separationPeriodCdPath}
              onChange={e => updateQuoteFieldValue(separationPeriodCdPath, e.target.value)}
              disabled
            />
          ),
          props: {xs: 6, sm: 6, md: 6},
        },
      ],
    },
  ];

  return <FormRowGrid rows={rows} />;
};

const GCI5Title = 'Separation Period For Different Critical Illness';
const GVCI5Title = 'Separation Period For Different Critical Illnesses';

export const SeperationPeriodForDifferentCriticalIllnessBlock = () => {
  const {getQuoteFieldValue, updateQuoteFieldValue} = useQuoteField();
  const {selectedPlan} = useSelector((state: ReducerState) => state.quoteForm);
  const parentPath = getParentSchedulePath(selectedPlan?.planIndex);
  const isSeparationPeriodAppliedPath = `${parentPath}.isSeparationPeriodApplied`;

  const isGVCI4Plan =
    getQuoteFieldValue<ImmutableMap<string, any>>(`benefitPackagingDetail.plans[${selectedPlan?.planIndex ?? 0}]`)?.get(
      'planCd'
    ) === 'GVCI4';

  const criticalIllnessSeparationPeriod: ConditionalSection[] = [
    {
      Component: CriticalIllnessSeparationPeriod,
      key: 'CriticalIllnessSeparationPeriod',
      label: 'CRITICAL ILLNESS SEPARATION PERIOD',
      disabled: true,
      isApplied: getQuoteFieldValue(isSeparationPeriodAppliedPath),
      onToggleVisibility: (visibility: boolean) => updateQuoteFieldValue(isSeparationPeriodAppliedPath, visibility),
    },
  ];

  return (
    <FormWrapper title={isGVCI4Plan ? GVCI5Title : GCI5Title} collapsible withSeparator>
      <QuoteFormConditionalSection sections={criticalIllnessSeparationPeriod} />
    </FormWrapper>
  );
};
